/* Hanezza's shared color vocabulary.
 * Order: merchant-configured Shopify swatch > known shade > two-tone color >
 * color-specific photo for a print > readable short label.
 * No invented gray shade for unknown option values.
 */
(function (root) {
  'use strict';
  if (root.HanezzaColorPalette && root.HanezzaColorPalette.version === 2) return;

  var shadeMap = Object.freeze({
    siyah:'#222222',black:'#222222',beyaz:'#ffffff',white:'#ffffff',
    gri:'#97969b',gray:'#97969b',grey:'#97969b',antrasit:'#494c52',
    krem:'#f4e8d2',ekru:'#eee9d9',bej:'#d3baa0',fildisi:'#efeadc',fil_disi:'#efeadc',
    vizon:'#a99c90',vizyon:'#a99c90',tas:'#bcb2a5',taba:'#ad835a',
    camel:'#b98a61',caramel:'#b98a61',cappuccino:'#a9917e',
    kahve:'#75513d',kahverengi:'#75513d',toprak:'#9c765b',
    tarcin:'#b87e58',kiremit:'#b66145',kremit:'#b66145',
    bordo:'#812c43',sarap_rengi:'#853450',visne:'#962b4c',
    kirmizi:'#ae2d3f',red:'#ae2d3f',nar:'#b6253d',
    nar_cicegi:'#ed5544',coral:'#e77e74',mercan:'#ec817a',
    pembe:'#e7a3bb',pudra:'#e9c2cd',gul:'#e7a0af',
    gul_kurusu:'#b77b8b',gulkurusu:'#b77b8b',fusya:'#d73f8c',
    somon:'#e8a99b',oranj:'#eb8a3e',orange:'#eb8a3e',
    sari:'#ead055',yellow:'#ead055',hardal:'#b99a43',dore:'#c9a14a',
    gold:'#c9a14a',gumus:'#b2b5ba',
    yesil:'#498357',green:'#498357',haki:'#75814f',
    acik_haki:'#a8ad82',koyu_haki:'#4c5936',olive:'#797f50',
    olive_yesili:'#797f50',yag_yesili:'#65764f',
    mint:'#afdac4',mint_yesili:'#afdac4',su_yesili:'#9bceba',
    benetton:'#24845e',fistik_yesili:'#91ba77',
    mavi:'#4d8abd',blue:'#4d8abd',light_blue:'#a5c7e5',
    'l._blue':'#a5c7e5',sax:'#255ba5',saxs:'#255ba5',saks:'#255ba5',
    lacivert:'#253655',dark_blue:'#253655',indigo:'#3e527f',
    petrol:'#247c83',turkuaz:'#52afad',
    mor:'#775486',purple:'#775486',murdum:'#633e5e',
    lila:'#ad96c9',leylak:'#bfa5d6',menekse:'#816aaf'
  });

  function normalize(value) {
    return String(value || '').trim().toLocaleLowerCase('tr-TR')
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/ı/g, 'i').replace(/[^a-z0-9 .\/_-]+/g, '')
      .replace(/[ ]+/g, ' ').trim();
  }
  function key(value) {
    return normalize(value).replace(/[ _]+v[0-9]+$/i, '').replace(/[- ]+/g, '_');
  }
  function hex(name) { return shadeMap[key(name)] || ''; }
  function isPattern(name) {
    return /leopar|leo|zebra|puan|cizg|desen|kaz_ayagi|varak|ponpon|c_t_r|citir|degrade|degrede/i.test(key(name));
  }
  function shortName(name) {
    return String(name || '?').trim().replace(/\s+/g, ' ').slice(0, 2).toLocaleUpperCase('tr-TR');
  }
  function visual(name, opts) {
    var data = opts || {};
    var nativeColor = String(data.nativeColor || '').trim();
    var nativeImage = String(data.nativeImage || '').trim();
    var variantImage = String(data.variantImage || '').trim();
    if (/^https?:\/\//.test(nativeImage)) return { kind:'image',image:nativeImage,source:'merchant' };
    if (/^#[0-9a-f]{3,8}$/i.test(nativeColor) || /^rgba?\(/i.test(nativeColor)) {
      return { kind:'solid',color:nativeColor,source:'merchant' };
    }
    if (isPattern(name)) {
      return /^https?:\/\//.test(variantImage)
        ? {kind:'image',image:variantImage,source:'variant'}
        : {kind:'label',label:shortName(name),source:'pattern-unmapped'};
    }
    var color = hex(name);
    if (color) return {kind:'solid',color:color,source:'palette'};
    var parts = String(name||'').split(/\s*[-/]\s*/).filter(Boolean);
    if (parts.length === 2) {
      var first=hex(parts[0]),second=hex(parts[1]);
      if (first && second) return {kind:'gradient',gradient:'linear-gradient(90deg,'+first+' 0%,'+first+' 50%,'+second+' 50%,'+second+' 100%)',source:'palette'};
    }
    if (/^https?:\/\//.test(variantImage)) return {kind:'image',image:variantImage,source:'variant'};
    return {kind:'label',label:shortName(name),source:'unmapped'};
  }
  function paint(dot, name, options) {
    if (!dot) return;
    var item = visual(name, options);
    dot.style.backgroundColor = '';
    dot.style.backgroundImage = '';
    dot.style.backgroundSize = '';
    dot.style.backgroundPosition = '';
    dot.textContent = '';
    if (item.kind === 'solid') dot.style.backgroundColor = item.color;
    else if (item.kind === 'gradient') dot.style.backgroundImage = item.gradient;
    else if (item.kind === 'image') {
      dot.style.backgroundImage = 'url(' + JSON.stringify(item.image) + ')';
      dot.style.backgroundSize = 'cover';
      dot.style.backgroundPosition = 'center';
    } else {
      dot.style.backgroundColor = '#f6f0f6';
      dot.textContent = item.label;
    }
    dot.setAttribute('data-hanezza-swatch-kind', item.kind);
    return item;
  }
  var api={version:2,visual:visual,paint:paint,normalize:normalize};
  root.HanezzaColorPalette = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})(typeof window !== 'undefined' ? window : globalThis);
